'use client';

import React from 'react';
import StoreProvider from '../../context/provider';
import HeroCardClientContent from './hero_card_client_content';
import { ProductLine } from '../../helpers/home_services.helper';

interface HeroCardClientProps {
  productLine: ProductLine;
  cardTitle: string;
}

export default function HeroCardClient({
  productLine,
  cardTitle,
}: HeroCardClientProps) {
  return (
    <StoreProvider>
      <HeroCardClientContent productLine={productLine} cardTitle={cardTitle} />
    </StoreProvider>
  );
}
